<template>
    <tr>
        <!-- <td>{{ item['.key'] }}</td> -->
        <td><b class="font-weight-bold">{{firmNameById(item.firm) || 'Not Assigned'}} </b></td>
        <td><b class="font-weight-bold" v-if="item.buyerId">{{item.buyerName}} </b></td>
        <template>    
        <td> <b class="green--text font-weight-bold"> {{getCredit(item) || 0 | amount}} </b></td>        
        <td> <b class="red--text font-weight-bold"> {{getDebit(item)|| 0 | amount }} </b></td>
        </template>
        <td><b class="font-weight-bold">{{item.voucherType}} </b></td>
        <td><b class="font-weight-bold">{{item.paymentType}}</b></td>
        <td><b class="font-weight-bold">{{item.status}}</b></td>
        <td ><b class="font-weight-bold"> {{item.remark}} </b></td>
    </tr>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const mapGlobalGetters = createNamespacedHelpers('Global')['mapGetters']
const mapBuyerGetters = createNamespacedHelpers('Buyer')['mapGetters']

import {DateTime, Interval} from 'luxon'

    export default {
        props:{
            item:{
                type:Object,
                default: () => {
                    return {}
                }
            },
            isCredited: {
                type: Boolean,
                default: true
            }, 
            firms: {
                type: Array,
                default: []
            },  
            sellers: {
            type: Object,
                default: []
            },
            buyers: {
                type: Object,
                default: []
            },
            status: {
                type: Array,
                default: () => {
                    return ['close']
                }
            },
            firmAssignment: {
                type: Boolean,
                default: false
            },
            heading: {
                type: String,
                default: ""
            },
            selectedFirm: {
                type: String,
                default: null
            },
            selectedDate: {
                type: String,
                default: () => {
                let today = new Date()
                return `${today.getFullYear()}-${today.getMonth()+1}-${today.getDate()}` 
                }
            }
        },
        data: () => ({
        }),
        computed:{
            ...mapGlobalGetters(['selectedBrand']),
            firmsByBrand () {
            return this.firms.filter((item) => 
                item['brand'] === this.selectedBrand
            )
        }
        },
        methods: {
            buyerById (id) {
                if (this.buyers[id]) {
                    return this.buyers[id]
                } else if (this.sellers[id]) {
                    return this.sellers[id]
                }
            },
            getCredit(item){
                if(('Opening Balance' == item.type  && item.status == 'paid') ||  ('Opening Balance' == item.type  && item.status == 'partial')) {
                    return !item.isBuyer? item['settledAmount'] : 0
                }
                if('LoanGiven' == item.type) {
                    if(item.loanTransaction) {
                        return 0;
                    } else {
                        return item.amount;
                    }
                }
                if('LoanTaken' == item.type) {
                    if(item.loanTransaction) {
                        return item.amount;
                    } else {
                        return 0;
                    }
                }
                if(item.type =='CustomerPayment') {
                    if (item.isBuyer) {
                    return 0;
                    } else {
                    return item['remainingAmount'];
                    }
                } else if('Advance' == item.type || 'Security' ==  item.type) {
                    return item.isUserCreated ? Number.parseFloat(0) : Number.parseFloat(item.settledAmount);
                }
                if(item.isBuyer) {
                    switch(item.status) {
                        case 'due' : {
                            return item.totalAmount || item.amount || 0;
                            break;
                        }
                        case 'paid' : {
                            return 0;
                            break;
                        }
                        case 'partial' : {
                            return 0;
                            break;
                        }
                    }
                } else {
                     switch(item.status) {
                        case 'due' : {
                            return  item.settledAmount || 0
                            break;
                        }
                        case 'paid' : {
                            return (Number.parseFloat(item['amountFromBank']) + Number.parseFloat(item['amountFromCash']));
                            // return Number.parseFloat(item['totalAmount']);
                            break;
                        }
                        case 'partial' : {
                            return (Number.parseFloat(item['amountFromBank']) + Number.parseFloat(item['amountFromCash']));
                            // return Number.parseFloat(item['paidAmount']);
                            break;
                        }
                    }
                }
            },
            getDebit(item){
                if(('Opening Balance' == item.type  && item.status == 'paid') ||  ('Opening Balance' == item.type  && item.status == 'partial')) {
                    return item.isBuyer? item['settledAmount'] : 0
                }
                if('LoanGiven' == item.type) {
                    if(item.loanTransaction) {
                        return item.amount;
                    } else {
                        return 0;
                    }
                   
                }
                if('LoanTaken' == item.type) {
                    if(item.loanTransaction) {
                        return 0;
                    } else {
                        return item.amount;
                    }
                }
                if(item.type =='CustomerPayment') {
                    if (!item.isBuyer) {
                    return 0;
                    } else {
                    return item['remainingAmount'];
                    }
                } else if('Advance' == item.type || 'Security' ==  item.type) {
                    return item.isUserCreated ? Number.parseFloat(item.amount) : Number.parseFloat(0);
                }
                if(item.isBuyer) {
                    switch(item.status) {
                        case 'due' : {
                            return item.settledAmount || 0;
                            break;
                        }
                        case 'paid' : {
                            return (Number.parseFloat(item['amountFromBank']) + Number.parseFloat(item['amountFromCash']));
                            // return Number.parseFloat(item['totalAmount']);
                            break;
                        }
                        case 'partial' : {
                            return (Number.parseFloat(item['amountFromBank']) + Number.parseFloat(item['amountFromCash']));
                            break;
                        }
                    }
                } else {
                     switch(item.status) {
                        case 'due' : {
                            return item.totalAmount || item.amount || 0
                            break;
                        }
                        case 'paid' : {
                            return 0;
                            break;
                        }
                        case 'partial' : {
                            return 0;
                            break;
                        }
                    }
                }
            },
            firmNameById (id) {
                let firm = this.firms.filter(item=> item['.key'] == id)[0]
                if (firm) {
                    return firm['name']
                }
            },
            getNumberOfDaysFromStartDate (createdAt, closedDate) {
                console.log (createdAt, closedDate)
                const startDate = DateTime.fromMillis(createdAt)
                if(!closedDate) {
                    closedDate = DateTime.local()
                } else {
                    closedDate = DateTime.fromMillis(closedDate)
                }
                const endDate = closedDate
                const interval = Interval.fromDateTimes(startDate, endDate)
                return Number.parseInt(interval.length('days'))
            },
            getTotalAmount (principal, rate, createdAt) {
                const time = this.getNumberOfDaysFromStartDate(createdAt) / 365
                rate = rate * 12 / 100
                return Number.parseFloat(principal * (1 + (rate * time))).toFixed(2)
            },
            getInterestValue (principal, rate, createdAt) {
                return (this.getTotalAmount(principal, rate, createdAt) - Number.parseFloat(principal)).toFixed(2)
            },
            
    }
}
</script>

<style>
.strip-table tbody tr:nth-child(odd){
    background-color: #d5d5d5;
}
</style>


// WEBPACK FOOTER //
// src/components/DailyTransactions/normalInvoice.vue